import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "absolute bottom-0 inset-x-0 px-container pb-16 lg:pb-32" }
const _hoisted_2 = { class: "font-display text-center" }
const _hoisted_3 = { class: "mb-4 text-2xl lg:text-4xl" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" TALLER EMERGENTEWORKSHOP DE COPRODUCCIÓN ENTRE REGIONES DE INDUSTRIA AUDIOVISUAL EMERGENTE ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" TALLER EMERGENTWORKSHOP DE COPRODUCCIÓ ENTRE REGIONS D’INDÚSTRIA AUDIOVISUAL EMERGENT ")
const _hoisted_6 = { class: "text-6xl lg:text-8xl text-amff-teal" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" VIERNES 29/07 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" DIVENDRES 29/07 ")
const _hoisted_9 = { class: "mt-4 text-center text-2xl lg:text-4xl font-display" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 13h - Teatre Mar i Terra ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 13h - Teatre Mar i Terra ")
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, " Uno de los desafíos que afrontan las productoras y creadores de comunidades con industria audiovisual emergente, es concretar coproducciones que permitan abordar proyectos más ambiciosos. Con este objetivo se ha programado un workshop con productores, gestores de televisiones públicas, responsables de fondos públicos destinados a la producción y representantes de asociaciones profesionales del sector, de Cantabria, Galicia Castilla La Mancha, Asturias, Navarra y Baleares.Programa ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Exposición de caso práctico:"),
    /*#__PURE__*/_createTextVNode(" “Sicília sense morts” coproducción de IB3 Televisió, A Punt, Filmin y Nova Televisió. Se analizarán las claves que han llevado a la concreción del acuerdo de coproducción. ")
  ]),
  /*#__PURE__*/_createVNode("li", null, " Presentación de los participantes de cada una de las CCAA - Networking y comida informal entre los participantes ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", null, " Un dels desafiaments que afronten les productores i creadors de comunitats amb indústria audiovisual emergent, és concretar coproduccions que permetin abordar projectes més ambiciosos. Amb aquest objectiu s’ha programat un workshop amb productors, gestors de televisions públiques, responsables de fons públics destinats a la producció i representants d’associacions professionals del sector, de Cantàbria, Galícia Castella-la Manxa, Astúries, Navarra i Balears. ", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("strong", null, "Participan:", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Exposició de cas pràctic:"),
    /*#__PURE__*/_createTextVNode(" “Sicília sense morts” coproducció d’IB3 Televisió, A Punt, Filmin i Nova Televisió, on s’analitzaran les claus que han portat a la concreció de l’acord de coproducció. ")
  ]),
  /*#__PURE__*/_createVNode("li", null, " Presentació dels participants de cadascuna de les CCAA - Networking i menjar informal entre els participants. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hero = _resolveComponent("Hero")
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_PageContent = _resolveComponent("PageContent")
  const _component_PageContainer = _resolveComponent("PageContainer")
  const _component_FollowFestival = _resolveComponent("FollowFestival")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Hero, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h1", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              (_ctx.currentLang === 'es')
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_4
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.currentLang === 'cat')
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_5
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_6, [
              (_ctx.currentLang === 'es')
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_7
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.currentLang === 'cat')
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_8
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            (_ctx.currentLang === 'es')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_10
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.currentLang === 'cat')
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_11
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_PageContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_PageTitle),
        (_ctx.currentLang === 'es')
          ? (_openBlock(), _createBlock(_component_PageContent, { key: 0 }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13,
                _hoisted_14
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_PageContent, { key: 1 }, {
              default: _withCtx(() => [
                _hoisted_15,
                _hoisted_16,
                _hoisted_17,
                _hoisted_18,
                _hoisted_19
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_FollowFestival)
  ], 64))
}